export const PERFORMANCE_VERSION = '2.0.0';

export const JSRunStageName = {
    ClientVarsReady: 'clientVarsReady',
    SDKDataInitialized: 'sdkDataInitialized',
    SDKParseJsonCost: 'sdkParseJsonCost', // SDK转换数据为对象耗时
    SDKInitDataCost: 'sdkInitDataCost', // SDK初始化Presentation对象耗时
    UIModelNew: 'uiModelNew',
    UIModelBinded: 'uiModelBinded',
    ConvertSdkToUI: 'convertSdkToUI',
    UpdateNeedShowBlank: 'updateNeedShowBlank',
};
